import React from 'react';

import {ContainerSummary, GridSummary} from 'constants/SampleConstants';
import StorableInfoTable from 'samples/storables/StorableInfoTable';
import HorizontalThrobber from 'ui-library/HorizontalThrobber';

import {ContainablePlateListing, ContainableContainerListing} from './StorableStore';

export interface StorableInfoTableFromListingProps {
  emptyTableText: string;
  listing: ContainableContainerListing | ContainablePlateListing;
  onChangeArchivePurposes: (archivePurposes: Array<string>) => void;
  selectedArchivePurposes: Array<string>;
  setOffset: (offset: number) => void;
  itemWord: string;
  containableId?: string;
}

function StorableInfoTableFromListing({
  emptyTableText,
  listing,
  onChangeArchivePurposes,
  selectedArchivePurposes,
  setOffset,
  itemWord,
  containableId,
}: StorableInfoTableFromListingProps): JSX.Element | null {
  if (!listing) {
    // Show nothing until listing is generated
    return null;
  }
  if (!listing.loadSuccess) {
    if (listing.isLoading) {
      // Initial load
      return <HorizontalThrobber />;
    } else {
      // Errored
      return <div className="u-faded">Data failed to load.</div>;
    }
  }
  if (listing.items == null) {
    // listing.items == null indicates that one or more of the items has been invalidated
    // so we wait for a fetch to get a fresh listing
    return <HorizontalThrobber />;
  }
  const storables = (listing.items as Array<ContainerSummary | GridSummary | null>).filter(
    (storable): storable is ContainerSummary | GridSummary => storable != null
  );

  return (
    <StorableInfoTable
      containableId={listing.param.containableId}
      emptyTableText={emptyTableText}
      storables={storables}
      storableSummaryExtras={listing.storableSummaryExtras}
      isLoading={listing.isLoading}
      onChangeArchivePurposes={onChangeArchivePurposes}
      pagination={listing.pagination}
      plateSummaryExtras={(listing as ContainablePlateListing).plateSummaryExtras}
      selectedArchivePurposes={selectedArchivePurposes}
      setOffset={setOffset}
      itemWord={itemWord}
      containerContentContainableId={containableId}
    />
  );
}

export default StorableInfoTableFromListing;
